import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import {
  AlertKey,
  InfoMessage,
  InformationMessageComponent,
} from "src/app/modules/shared/components/alerts/information-message/information-message.component";
import { ButtonModule } from "@storeblocks/button-ng";
import { FmsService } from "src/app/services/fms.service";

@Component({
  selector: "app-errors",
  templateUrl: "errors.component.html",
  styleUrls: ["errors.component.scss"],
  standalone: true,
  imports: [InformationMessageComponent, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorsComponent {
  readonly fmsService = inject(FmsService);

  public readonly AlertKey = AlertKey;
  public readonly infoMessage: InfoMessage | undefined = (() => {
    const messages = this.fmsService.getJSON<InfoMessage[]>("infoMessage");
    return Array.isArray(messages) ? messages.find((m) => m.key === AlertKey.Dashboard) : undefined;
  })();

  public readonly headline: string = this.fmsService.getText("errorspage.headline");
  public readonly information: string = this.fmsService.getText("errorspage.information");
  public readonly buttonText: string = this.fmsService.getText("errorspage.button.reload");
  public readonly image: string = this.fmsService.getText("errorspage.image");

  public reloadPage(): void {
    location.reload();
  }
}
